import { Empty, Pagination, Tag } from "antd";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import * as Apis from "../../../../utils/helper/enum";
import { changeLoader } from "../../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../../../utils/global/globalRequest";
import toast from "react-hot-toast";
import { paginationLimit, paginationPages } from "../../../../utils/helper/constants";

const CannedMachines = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [totalRows, setTotalRows] = useState(0);

  const getAllMachines = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        seller_id: id,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(
        Apis.MANAGE_CANNED_VENDING_MACHINE.GET,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data || apiResponse?.data?.rows || apiResponse?.data || []);
        setTotalRows(apiResponse?.data?.paginator?.itemCount || apiResponse?.paginator?.itemCount || apiResponse?.data?.total || 0);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    if (id) {
      getAllMachines();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel, id]);

  const getStatusColor = (status) => {
    const s = String(status ?? "").toLowerCase();
    switch (s) {
      case "1":
      case "live":
      case "active":
        return "green";
      case "0":
      case "offline":
      case "inactive":
        return "red";
      case "low":
        return "orange";
      default:
        return "default";
    }
  };

  const getDoorStatusTag = (doorStatus, isOpen) => {
    const val = doorStatus !== undefined ? doorStatus : isOpen;
    if (
      val === true ||
      val === "true" ||
      val === "1" ||
      val === 1 ||
      val === "open" ||
      val === "Open"
    ) {
      return <Tag color="orange">Open</Tag>;
    }
    if (
      val === false ||
      val === "false" ||
      val === "0" ||
      val === 0 ||
      val === "closed" ||
      val === "Closed"
    ) {
      return <Tag color="green">Closed</Tag>;
    }
    return <Tag color="default">Closed</Tag>;
  };

  return (
    <>
      <div className="relative overflow-x-auto mt-4 px-1">
        <table className="w-full text-left text-sm text-gray-500">
          <thead className="text-gray-700 capitalize text-xs bg-gray-50">
            <tr>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">Name</th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">Machine ID (CSN)</th>
              <th scope="col" className="px-3 py-3">District</th>
              <th scope="col" className="px-3 py-3">Address</th>
              <th scope="col" className="px-3 py-3">Products</th>
              <th scope="col" className="px-3 py-3">Pct</th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">Door Status</th>
              <th scope="col" className="px-3 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {list?.length ? (
              list
                ?.filter((item) => item.status !== "deleted" && item.Status !== "deleted")
                ?.map((item, index) => (
                <tr className="bg-white border-b" key={index}>
                  <td className="px-3 py-4 vertical-top font-medium text-gray-900">
                    {item?.name ||
                      item?.localName ||
                      item?.Name ||
                      item?.portalName ||
                      item?.csn ||
                      item?.csnId ||
                      item?.SN ||
                      "-"}
                  </td>
                  <td className="px-3 py-4 vertical-top font-mono">
                    {item?.csn ||
                      item?.csnId ||
                      item?.SN ||
                      item?.winnsenClientId ||
                      "-"}
                  </td>
                  <td className="px-3 py-4 vertical-top">{item?.district || "-"}</td>
                  <td className="px-3 py-4 vertical-top">{item?.address || "-"}</td>
                  <td className="px-3 py-4 vertical-top">{item?.productsCount || 0}</td>
                  <td className="px-3 py-4 vertical-top">{item?.pct || 0}%</td>
                  <td className="px-3 py-4 vertical-top">
                    {getDoorStatusTag(item?.doorStatus, item?.isOpen)}
                  </td>
                  <td className="px-3 py-4 vertical-top">
                    <Tag color={getStatusColor(item?.status ?? item?.Status)}>
                      {item?.status === "1" ||
                      item?.status === 1 ||
                      item?.Status === "1" ||
                      item?.Status === 1 ||
                      item?.status === "active" ||
                      item?.status === "live"
                        ? "Active"
                        : "Inactive"}
                    </Tag>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={8} className="text-center py-4">
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {list?.length ? (
        <div className="text-right mt-4">
          <Pagination
            defaultCurrent={1}
            total={totalRows}
            pageSizeOptions={paginationPages}
            showSizeChanger={true}
            current={paginationModel?.page}
            pageSize={paginationModel?.limit}
            onChange={(page) => setPaginationModel((prev) => ({ ...prev, page: page }))}
            onShowSizeChange={(current, size) => setPaginationModel((prev) => ({ ...prev, limit: size }))}
          />
        </div>
      ) : null}
    </>
  );
};

export default CannedMachines;
